"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_TITLE = exports.SYSTEM_TYPE_IDENTIFIER = exports.EXTERNAL_ID_IDENTIFIER = exports.EXTERNAL_ID_DELIMITER = void 0;
exports.EXTERNAL_ID_DELIMITER = '@';
exports.EXTERNAL_ID_IDENTIFIER = 'epic_osw';
exports.SYSTEM_TYPE_IDENTIFIER = 'epic';
exports.IFRAME_TITLE = 'Schedule Your Appointment';
//# sourceMappingURL=EpicOSW.js.map